import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

export default function LlmsManagement() {
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchLlms = async () => {
      try {
        const response = await ApiRequest("GET", ApiEndpoints.llms.view);
        setContent(response?.llms?.content || "");
      } catch (error) {
        toast.error(error.response?.data?.message || "Unable to load LLMS file.");
      } finally {
        setLoading(false);
      }
    };

    fetchLlms();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrors([]);

    if (!content.trim()) {
      setErrors(["LLMS content is required."]);
      return;
    }

    setSaving(true);
    try {
      const response = await ApiRequest("POST", ApiEndpoints.llms.update, { content });
      toast.success(response.message);
    } catch (error) {
      const message = error.response?.data?.message || "Unable to update LLMS file.";
      setErrors([message]);
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  const pagename = {
    name: "LLMS Management",
    user: "Admin",
    innerpage: "LLMS Management",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>LLMS Content<small>*</small></label>
                  </div>
                  <textarea
                    name="content"
                    value={content}
                    onChange={(event) => setContent(event.target.value)}
                    className="form-control"
                    rows="28"
                    disabled={loading || saving}
                    placeholder={loading ? "Loading LLMS file..." : "Enter the content for /llms.txt."}
                    spellCheck="false"
                    style={{ height: "auto", fontFamily: "monospace", whiteSpace: "pre", overflow: "auto" }}
                  />
                </div>
              </div>

              {errors.length > 0 && (
                <div className="col-lg-12">
                  <div className="alert alert-danger">
                    {errors.map((error) => <div key={error}>{error}</div>)}
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <button className="default-btn" type="submit" disabled={loading || saving}>
                  {saving ? "Saving..." : "Save LLMS File"}<span></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
